import { localizedMedia, localizedLink } from '../i18n/resources';
import { t } from '../i18n';
import {React, useState} from "react";
import { useNavigate } from "react-router-dom";
import { slide as Menu } from 'react-burger-menu';
import { Modal } from 'react-responsive-modal';
import logoMainOriginal from "../img/logo_garage.svg";
import InnerModal from "./InnerModal";
import InnerModalSzkolenie from "./InnerModalSzkolenie";
import InnerModalOpony from "./InnerModalOpony";
import Cennik from "./Cennik";
import menHamOriginal from "../img/menham.svg";
import 'react-responsive-modal/styles.css';
import InnerModalAutoZS from "./InnerModalAutoZS";

const logoMain = localizedMedia(logoMainOriginal, "logo_garage.svg");
const menHam = localizedMedia(menHamOriginal, "menham.svg");

const Navbar = (props) => {
    let szkoltest = false;
    let butname = 'Umów się na wizytę';
    if (props.szkoleniejest === true) {
        szkoltest = true;
        butname = 'Zapisz się na szkolenie';
    };
    // autozakupjest
    let autotest = false;
    if (props.autozakupjest === true) {
        autotest = true;
        butname = 'Umów się';
    };
    const [open, setOpen] = useState(false);
    const [openSecond, setOpenSecond] = useState(false);
    const [openO, setOpenO] = useState(false);
    const navigate = useNavigate();
    const {services, service} = props;
    const [openAutoZS, setOpenAutoZS] = useState(false);
    const handleMapServices = () => {
        let temp = [...services];
        const listedServices = temp.sort((a, b) => a.title > b.title ? 1 : -1).map((service)=>{
            if ((service.sourceId || service.id) != 2 && (service.sourceId || service.id) != 7) {
            return <a key={service.id} href={'/' + service.garage_category.path +"/"+ service.path}>
                 <p>{service.title}</p>
            </a>
            };
        });
        return listedServices;
    }

    const handleMapMobileServices = () => {
        let temp = [...services];
        const listedServices = temp.sort((a, b) => a.title > b.title ? 1 : -1).map((service)=>{
            return <a key={service.id} id={service.title} className="menu-item" href={'/' + service.garage_category.path +"/"+ service.path}>{service.title}</a>
        });
        return listedServices;
    }

    return(
        <nav className="nav">
        <Menu right>
            <a hidden id="promo" className="menu-item" href={'/promocje'}>{t("Promocje")}</a>
            <a id="cennik" className="menu-item menu-item-bold" onClick={() => setOpenSecond(true)}>{t("Cennik")}</a>
            {services && handleMapMobileServices()}
            <a hidden key="" id="mps" className="menu-item" href={'/samochod'}>{t("Sprzedaż lub zakup auta")}</a>
            <a key="" id="mpj" className="menu-item" href={'/szkolenie/main'}>{t("Szkolenia")}</a>
            <a key="" id="mpl" className="menu-item" href={'/program-lojalnosciowy'}>{t("Program Lojalnościowy")}</a>
            <a id="kontakt" className="menu-item" href={'/kontakt'}>{t("Kontakt")}</a>
        </Menu>
            <Modal open={openSecond} onClose={() => setOpenSecond(false)} center>
                <Cennik />
            </Modal>
            {szkoltest === false && 
            <Modal open={open} onClose={() => setOpen(false)} center>
                <InnerModal setOpen={setOpen} service={service && service}/>
            </Modal>
            }
            {(service && (service.sourceTitle || service.title) == 'Felgi i opony') &&
                <Modal open={openO} onClose={() => setOpenO(false)} center>
                    <InnerModalOpony setOpenO={setOpenO}/>
                </Modal>
            }
            {szkoltest === true && 
                <Modal open={open} onClose={() => setOpen(false)} center>
                    <InnerModalSzkolenie dataszko={'05.11.2022'}/>
                </Modal>
            }
            {autotest === true && 
                <Modal open={openAutoZS} onClose={() => setOpenAutoZS(false)} center>
                    <InnerModalAutoZS setOpenAutoZS={setOpenAutoZS}/>
                </Modal>
            }
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-sm-2">
                        <img className="logo-nav" onClick={()=>{navigate('/')}} src={ logoMain } alt={t("logo-main")}/>
                    </div>
                    <div className="col-7 col-sm-7 hide-mobile">
                        
                    </div>
                    <div className="col-2 col-sm-2">
    {(service && (service.sourceTitle || service.title) === 'Felgi i opony' && !autotest) && (
        <button className="nav-res" onClick={() => setOpenO(true)}>{t(butname)}</button>
    )}

    {(butname === 'Zapisz się na szkolenie') && (
        <button
            className={`nav-res nav-res-font`}
            onClick={(e) => {
                const isMobile = window.innerWidth <= 768;
                if (isMobile) {
                    window.location.href = localizedLink('https://szkolenia.soft99garage.pl/');
                    return;
                }

                e.preventDefault();
                const width = 900;
                const height = 800;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;

                window.open(
                    localizedLink('https://szkolenia.soft99garage.pl/'),
                    '_blank',
                    `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
                );
            }}
        >
            {t(butname)}
        </button>
    )}


</div>
                    <div className="col-1 col-sm-1">
                        <div className="btn-group dontshowmeonmobile">
                            <div className="dropdown-toggle main-menu-nav-tog" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={menHam} alt=""/>
                            </div>
                            <ul className="dropdown-menu dropdown-menu-end main-menu-nav-drop">
                                <a hidden id="promo" className="menu-item" href={'/promocje'}>{t("Promocje")}</a>
                                <a id="cennik" className="menu-item menu-item-bold" onClick={() => setOpenSecond(true)}>{t("Cennik")}</a>
                                {services && handleMapServices()}
                                <a hidden key="" id="mps" className="menu-item" href={'/samochod'}>{t("Sprzedaż lub zakup auta")}</a>
                                <a key="" id="mpj" className="menu-item" href={'/szkolenie/main'}>{t("Szkolenia")}</a>
                                <a key="" id="mpl" className="menu-item" href={'/program-lojalnosciowy'}>{t("Program Lojalnościowy")}</a>
                                <a id="kontakt" className="menu-item" href={'/kontakt'}>{t("Kontakt")}</a>
                                <a id="regulamin" className="menu-item" target="_blank" href={localizedLink('/reg/nowy_regulamin_myjnia.pdf')}>{t("Regulamin")}</a>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;